import React, {
	useRef,
	useState,
	useEffect,
	useLayoutEffect,
	useCallback
} from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import { Available, Distance, ensure_slug } from "../utils";
import useDynamicRefs from "use-dynamic-refs";
import useMapDataContext from "../contexts/MapDataContext";
import useUserInfoContext from "../contexts/UserInfoContext";

const SmartMap = ({ google, markers, activeId, currentFilter }) => {
	const { userLocation } = useUserInfoContext();
	const [activeMarkerObj, setActiveMarkerObj] = useState(null);
	const [getRef, setRef] = useDynamicRefs();
	const [center, setCenter] = useState({ lat: 63.75894349578442, lng: 11.393644956500847 });
	const [bounds, setBounds] = useState();
	const mapRef = useRef();

	useEffect(() => {
		var _bounds = new google.maps.LatLngBounds();
		markers.map(marker => {
			// if (marker.municipality === ensure_slug(currentFilter.municipality) && currentFilter.types[marker.type] && marker.lat && marker.lng) {
			if (
				marker.municipality ===
					ensure_slug(currentFilter.municipality) &&
				marker.lat &&
				marker.lng
			) {
				_bounds.extend({
					lat: parseFloat(marker.lat),
					lng: parseFloat(marker.lng)
				});
			}
		});
		if (
			_bounds[0]?.g != 180 ||
			_bounds[0]?.i != -180 ||
			_bounds[1]?.g != 1 ||
			_bounds[1]?.i != -1
		) {
			if (_bounds.isEmpty()) {
				console.log('empty');
				// If _bounds is empty (no valid bounds), use center lat and lng as default
				setCenter({ lat: center.lat, lng: center.lng });
			} else {
				console.log('not empty');
				setBounds(_bounds);
				setCenter({
					lat: _bounds[0]?.i,
					lng: _bounds[1]?.i
				});
			}
		}
		setActiveMarkerObj(null);
	}, [markers, currentFilter]);

	const setActiveMarker = id => {
		var marker = getRef(id).current.marker;
		marker.map = null;
		if (activeMarkerObj?.meta.markerId != marker.meta.markerId) {
			setActiveMarkerObj(marker);
		}
	};

	useEffect(() => {
		if (activeId) {
			const timeout = setTimeout(() => {
				setActiveMarker(activeId);
			}, 100);
			return () => clearTimeout(timeout);
		} else {
			setActiveMarkerObj(null);
		}
	}, [activeId]);

	return (
		<Map
			google={google}
			initialCenter={center}
			defaultZoom={5}
			bounds={bounds}
			ref={mapRef}
		>
			{markers &&
				markers.map((marker, index) => {
					return (
						<Marker
							key={`marker_${marker.markerId}`}
							index={index}
							visible={
								marker.municipality ===
									ensure_slug(currentFilter.municipality) &&
								currentFilter.types[marker.type]
									? true
									: false
							}
							position={{
								lat: parseFloat(marker.lat),
								lng: parseFloat(marker.lng)
							}}
							// onClick={onMarkerClick}
							onClick={e => setActiveMarker(e.meta.markerId)}
							name={marker.title}
							meta={marker}
							zIndex={
								marker.type === "gjenvinningsstasjoner"
									? 2
									: marker.type === "returpunkter"
									? 1
									: 0
							}
							ref={setRef(marker.markerId)}
							icon={{
								url: `/wp-content/themes/innherred-renovasjon-2020/bb-modules/smart-map/assets/marker_${marker.type[0]}_outline.png`,
								scaledSize: {
									height: 52,
									width: 52
								}
							}}
						></Marker>
					);
				})}
			<InfoWindow
				marker={activeMarkerObj}
				visible={activeMarkerObj ? true : false}
			>
				<div className="marker__infowindow">
					{activeMarkerObj && (
						<h3 className="marker__infowindow__title">
							{activeMarkerObj.name}
						</h3>
					)}
					{activeMarkerObj?.meta?.type ===
						"gjenvinningsstasjoner" && (
						<Available source="map" marker={activeMarkerObj.meta} />
					)}
					{activeMarkerObj && userLocation && (
						<Distance distance={activeMarkerObj.meta.distance} />
					)}
					<h4 className="marker__infowindow__allowed-types__title">
						Her kan du levere:
					</h4>
					<ul className="marker__infowindow__allowed-types">
						{activeMarkerObj?.meta?.waste_types.map(waste => {
							let image =
								"/wp-content/themes/innherred-renovasjon-2020/images/sorting-guide/";
							switch (waste) {
								case "":
									image = "";
									break;
								case "Papp, papir og kartong":
									image += "papp.jpg";
									break;
								case "klær og sko":
									image += "tekstiler.jpg";
									break;
								case "klær":
									image += "tekstiler.jpg";
									break;
								case "Småelektronikk":
									image += "smaelektronikk.jpg";
									break;
								case "Små elektronikk støvsuger":
									image += "smaelektronikk-stovsuger.jpg";
									break;
								default:
									image += `${waste.toLowerCase()}.jpg`;
							}
							return (
								<li
									data-waste={waste}
									className="marker__infowindow__allowed-type"
									key={waste}
								>
									<img
										src={image}
										alt={waste}
										title={waste}
									></img>
								</li>
							);
						})}
					</ul>
					{activeMarkerObj?.meta?.type ===
						"gjenvinningsstasjoner" && (
						<a href={activeMarkerObj.meta.slug}>Les mer</a>
					)}
				</div>
			</InfoWindow>
		</Map>
	);
};

export default GoogleApiWrapper({
	apiKey: "AIzaSyBBYU9aeVRs-Wq2uAZ0OIQ9VBJTJwjOgWs"
})(SmartMap);
